import { IDataTableColumn } from '../../dataTable/DataTable/model';

const inputDeviceColumns: IDataTableColumn<any>[] = [
  {
    name: 'Digital Input ID',
    selector: (row: any) => row.DigitalInputID,
    sortable: true,
    sortFunction: (rowA: any, rowB: any): number => {
      const idA = parseInt(rowA.DigitalInputID, 10); // Convert string to number
      const idB = parseInt(rowB.DigitalInputID, 10); // Convert string to number
      return idA - idB; // Sort numerically
    },
  },
  {
    name: 'Digital Input',
    selector: 'DigitalInput',
    sortable: true,
  },
  {
    name: 'Global Device ID',
    selector: 'GlobalDeviceID',
    sortable: true,
  },
  {
    name: 'Device Name',
    selector: 'DeviceName',
    sortable: true,
  },
  {
    name: 'Device Description',
    selector: 'DeviceDesc',
    sortable: true,
  },
  {
    name: 'Type',
    selector: 'Type',
    sortable: true,
  },
];

export default inputDeviceColumns;
